module.exports = __webpack_public_path__ + "img/i4.eb96a267.jpg";